var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgS2IconWedge = function SvgS2IconWedge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 450 450"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "s2_icon_wedge_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h450v450H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s2_icon_wedge_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#464646",
    strokeWidth: 26,
    d: "M53.5 213.516 148.517 64.5 396.5 98.888m-343 114.628L74.383 386.5l306.455-122.443L396.5 98.888m-343 114.628 343-114.628",
    "data-name": "icon_volume_triangle"
  }))));
};
export default SvgS2IconWedge;